module.exports = __webpack_public_path__ + "img/SMARTINOUT.da071ddd.jpg";